import type React from 'react';
import { styled } from 'styled-components';

import { BaseNotification, type BaseNotificationProps } from './Base.tsx';

type AppBarNotificationProps = Omit<BaseNotificationProps, 'closeable' | 'role'> & {
  onClick: () => void;
  onClose: () => void;
};

const StyledNotification = styled(BaseNotification)`
  width: 100%;
  padding: 12px 16px;
  gap: 12px;
  border-radius: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  border-top: none;
  border-left: none;
  border-right: none;
`;

export const AppBarNotification: React.FC<AppBarNotificationProps> = (props) => <StyledNotification {...props} closeable role='alert' />;
